
import {
  GET_SETTINGS_LIST_SUCCESS,
  TOGGLE_SETTING_LOADING,
} from './actions';
import { CLEAR_DATA } from '../actions';

const initState = {
  id: '',
  userId: '',
  alertOn: true,
  alertStart: '00:00:00',
  alertEnd: '24:00:00',
  alertFamilyIds: [],
  isLoading: false,
};

const settingReducer = (state = initState, action) => {
  // console.log('settingReducer', state, action);

  const { type, payload } = action;
  switch (type) {
    case GET_SETTINGS_LIST_SUCCESS: {
      const { response } = payload;
      return {
        ...state,
        ...response,
      };
    }

    case TOGGLE_SETTING_LOADING: {
      const { isLoading } = payload;
      return {
        ...state,
        isLoading,
      };
    }

    case CLEAR_DATA:
      return initState;

    default:
      return state;
  }
};

export default settingReducer;
